import React from "react"
import {
	Grid,
	Box,
	Container,
	// Accordion,
	// AccordionSummary,
	// AccordionDetails,
} from "@mui/material"
import Icon from "@mdi/react"
import {
	// mdiChevronDown,
	mdiArrowRightThick,
	mdiAccountHardHat,
	mdiTruckDelivery,
	mdiCertificate,
	mdiFlash,
	mdiKeyVariant,
} from "@mdi/js"

import SaPlaner from "svg/SA-Planer.svg"

import Link from "components/i18n/Link"
import SEO from "@secureo/common/components/SEO"
import BreadCrumbs, { BreadCrumb } from "components/BreadCrumbs"

import { CustomAppProps } from "pages/_app"
import Button from "components/Buttons/Button"
import formatPrice from "@secureo/common/utils/forex/formatPrice"
import { flatFeesByCurrencyCode } from "@secureo/common/config/shippingZonesAndCosts"

const name = "Schließanlage planen"

export const currentPath: BreadCrumb = {
	label: name,
	href: `/locking-system`,
}

const LockingSystemTypesPage = ({ asPath, locale }: CustomAppProps) => {
	return (
		<>
			<SEO
				asPath={asPath}
				categoryName={name}
				title={name}
				appendLocalizedShopNameWithPipe
				description={""}
			/>
			<BreadCrumbs locale={locale} currentPath={currentPath} ancestors={[]} />

			<Container>
				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<Box
							mt={5}
							style={{
								color: "#4691CE",
								textTransform: "uppercase",
								fontSize: 13,
							}}
						>
							<strong>Schritt für Schritt zur Schließanlage</strong>
						</Box>
						<Box mb={2}>
							<h1 style={{ margin: 0 }}>Schließanlagen Konfigurator</h1>
						</Box>
						<p>
							Planen und konfigurieren Sie Ihre maßgeschneiderte Schließanlage schnell
							und einfach online. Wählen Sie Ihr optimales Schließsystem eines
							beliebigen Herstellers. Anschließend können Sie die benötigten Schlüssel
							oder Schlüsselgruppen hinzufügen. Durch das Setzen von Kreuzen bei jedem
							Schlüssel können Sie individuell die Schließberechtigungen für die
							Zylinder und Schließkomponenten definieren.Selektieren Sie die
							gewünschten Zylindertypen und bestimmen Sie deren Länge und Ausführung.
						</p>
						<p>
							Der Preis der Anlage aktualisiert sich dabei in Echtzeit. So haben Sie
							die genauen Kosten stets im Blick.
						</p>
						<div>
							<Link href="/locking-system/mechanic">
								<Button color="primary" style={{ maxWidth: 200 }}>
									<Box mr={1}>Jetzt planen</Box>{" "}
									<Icon path={mdiArrowRightThick} size={1} />
								</Button>
							</Link>
						</div>
					</Grid>
					<Grid item xs={12} md={6}>
						<SaPlaner style={{ width: "100%", height: "100%", objectFit: "contain" }} />
					</Grid>

					<Grid item xs={12} md={4}>
						<Box mt={4} style={{ fontSize: 60, color: "#4691CE" }}>
							<strong>1</strong>
						</Box>
						<h2 style={{ marginTop: 0, fontSize: 20 }}>Schließsystem wählen</h2>
						<p>
							Im ersten Schritt müssen Sie sich für ein mechanisches oder
							elektronisches Schließsystem entscheiden, wobei in den meisten Fällen
							ein mechanisches Schließsystem zum Einsatz kommt. Suchen Sie sich ein
							beliebiges System von einem unserer zahlreichen Hersteller aus. Für eine
							leichtere Orientierung können Sie die angegebenen Sicherheitsstufen in
							Betracht ziehen.
						</p>
					</Grid>
					<Grid item xs={12} md={4}>
						<Box mt={4} style={{ fontSize: 60, color: "#4691CE" }}>
							<strong>2</strong>
						</Box>
						<h2 style={{ marginTop: 0, fontSize: 20 }}>Berechtigungen vergeben</h2>
						<p>
							Durch das Setzen eines Kreuzes beim jeweiligen Schlüssel definieren Sie
							in der Schließmatrix die Schließberichtigung.
						</p>
					</Grid>
					<Grid item xs={12} md={4}>
						<Box mt={4} style={{ fontSize: 60, color: "#4691CE" }}>
							<strong>3</strong>
						</Box>
						<h2 style={{ marginTop: 0, fontSize: 20 }}>Optionen wählen</h2>
						<p>
							Bestimmen Sie die Eigenschaft der jeweiligen Schließkomponente und
							passen Sie sie perfekt an Ihre Gegebenheiten an. Damit ist u.a. die
							Auswahl der Länge sowie optionale Sonderausstattungen gemeint.
						</p>
					</Grid>
				</Grid>
			</Container>

			<Box my={5} py={5} style={{ backgroundColor: "#4691CE", color: "#fff" }}>
				<Container>
					<Box py={3} mx={1}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Box
									style={{
										textTransform: "uppercase",
										fontSize: 13,
									}}
								>
									<strong>Warum mit Uns?</strong>
								</Box>
								<Box mb={2}>
									<h2 style={{ margin: 0 }}>
										Ihre Vorteile bei Digitalzylinder-Shop
									</h2>
								</Box>
							</Grid>
							<Grid item xs={12} md={4}>
								<Box my={2} style={{ display: "flex" }}>
									<div
										style={{
											background: "rgba(255, 255, 255, 0.2)",
											padding: 8,
											marginRight: 10,
											height: 30,
											width: 35,
											borderRadius: 4,
											textAlign: "center",
										}}
									>
										<Icon path={mdiAccountHardHat} size={1} />
									</div>

									<strong>
										Einfach und schnelle online Abwicklung für Privatanwender,
										sowie für Profis.
									</strong>
								</Box>
							</Grid>
							<Grid item xs={12} md={4}>
								<Box my={2} style={{ display: "flex" }}>
									<div
										style={{
											background: "rgba(255, 255, 255, 0.2)",
											padding: 8,
											marginRight: 10,
											height: 30,
											width: 35,
											borderRadius: 4,
											textAlign: "center",
										}}
									>
										<Icon path={mdiTruckDelivery} size={1} />
									</div>

									<strong>
										Versandkostenfreie Lieferung ab einem Einkaufswert von{" "}
										{formatPrice(
											flatFeesByCurrencyCode.EUR
												.flatFeeForSmallAmountThresholdGrossCents,
											"de-DE",
										)}{" "}
										nach Deuschland, Österreich und in die Schweiz.
									</strong>
								</Box>
							</Grid>
							<Grid item xs={12} md={4}>
								<Box my={2} style={{ display: "flex" }}>
									<div
										style={{
											background: "rgba(255, 255, 255, 0.2)",
											padding: 8,
											marginRight: 10,
											height: 30,
											width: 35,
											borderRadius: 4,
											textAlign: "center",
										}}
									>
										<Icon path={mdiCertificate} size={1} />
									</div>

									<strong>
										Fachmännische Beratung, sowie ein herausragendes
										Produktsortiment namhafter Hersteller.
									</strong>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Container>
			</Box>

			<Container id="plan-your-locking-system">
				<Box py={2}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<h2 style={{ marginBottom: 0 }}>
								Erstellen Sie jetzt Ihre Schließanlage
							</h2>
							<strong>Was für ein Schließsystem benötigen Sie?</strong>
						</Grid>
						<Grid item xs={12} md={6}>
							<Box
								my={5}
								mx={1}
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									padding: 10,
									borderRadius: 5,
									boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.25)",
								}}
							>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Icon path={mdiKeyVariant} size={1} color="#4691CE" />
									<Box ml={1}>Mechanisch</Box>
								</div>
								<div style={{ maxWidth: 200 }}>
									<Link href="/locking-system/mechanic">
										<Button color="primary">
											Jetzt planen <Icon path={mdiArrowRightThick} size={1} />
										</Button>
									</Link>
								</div>
							</Box>
						</Grid>
						<Grid item xs={12} md={6}>
							<Box
								my={5}
								mx={1}
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									padding: 10,
									borderRadius: 5,
									boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.25)",
								}}
							>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Icon path={mdiFlash} size={1} color="#4691CE" />
									<Box ml={1}>Elektronisch</Box>
								</div>
								<div style={{ maxWidth: 200 }}>
									{/* <Link href="/locking-system/electronic"> */}
									<Button color="primary" disabled>
										In Kürze verfügbar!
										{/* Jetzt planen <Icon path={mdiArrowRightThick} size={1} /> */}
									</Button>
									{/* </Link> */}
								</div>
							</Box>
						</Grid>
					</Grid>
				</Box>

				{/* <Box py={5} id="information">
					<Grid xs={12}>
						<Box
							mt={5}
							style={{
								color: "#4691CE",
								textTransform: "uppercase",
								fontSize: 13,
							}}
						>
							<strong>Was gilt es zu beachten?</strong>
						</Box>
						<Box mb={2}>
							<h2 style={{ margin: 0 }}>Wissenswertes bevor Sie loslegen</h2>
						</Box>
					</Grid>

					<Grid>
						<Accordion
							style={{ boxShadow: "none", background: "none" }}
							defaultExpanded
						>
							<AccordionSummary
								id="what"
								expandIcon={<Icon path={mdiChevronDown} size={1} />}
								aria-controls="what"
							>
								<h3 style={{ margin: 0 }}>
									<strong>Was ist eine Schließanlage?</strong>
								</h3>
							</AccordionSummary>
							<AccordionDetails>
								<div style={{ overflow: "hidden" }}>
									Auf der Suche nach einer speziellen Dienstleistung oder einer
									Firma ist es heutzutage selbstverständlich, online Suchmaschinen
									zu Rate zu ziehen. Man braucht nur einige Schlagworte einzugeben
									und erhält sofort eine große Auswahl präsentiert, wobei den
									Suchergebnissen auf den ersten beiden Seiten die meiste
									Aufmerksamkeit zukommt. Einen Platz unter den Top-Listungen zu
									ergattern ist gar nicht so einfach. Neben einem ansprechenden
									Webdesign sind auch ein umfangreiches Onlinemarketing und ein
									Abstimmen auf die Suchmaschinen dafür ausschlaggebend. Als
									Internetagentur mit langjähriger Erfahrung wissen wir, worauf es
									ankommt, um gefunden zu werden. Wir pushen Ihren Online Auftritt
									und helfen Ihnen mit unseren Schulungen dabei auch selbst
									Schritte in die richtige Richtung zu setzen.
								</div>
							</AccordionDetails>
						</Accordion>

						<Accordion style={{ boxShadow: "none", background: "none" }}>
							<AccordionSummary
								id="attention"
								expandIcon={<Icon path={mdiChevronDown} size={1} />}
								aria-controls="attention"
							>
								<h3 style={{ margin: 0 }}>
									<strong>
										Was muss ich bei der Planung einer Schließanlage beachten?
									</strong>
								</h3>
							</AccordionSummary>
							<AccordionDetails>
								<div style={{ overflow: "hidden" }}>
									Auf der Suche nach einer speziellen Dienstleistung oder einer
									Firma ist es heutzutage selbstverständlich, online Suchmaschinen
									zu Rate zu ziehen. Man braucht nur einige Schlagworte einzugeben
									und erhält sofort eine große Auswahl präsentiert, wobei den
									Suchergebnissen auf den ersten beiden Seiten die meiste
									Aufmerksamkeit zukommt. Einen Platz unter den Top-Listungen zu
									ergattern ist gar nicht so einfach. Neben einem ansprechenden
									Webdesign sind auch ein umfangreiches Onlinemarketing und ein
									Abstimmen auf die Suchmaschinen dafür ausschlaggebend. Als
									Internetagentur mit langjähriger Erfahrung wissen wir, worauf es
									ankommt, um gefunden zu werden. Wir pushen Ihren Online Auftritt
									und helfen Ihnen mit unseren Schulungen dabei auch selbst
									Schritte in die richtige Richtung zu setzen.
								</div>
							</AccordionDetails>
						</Accordion>

						<Accordion style={{ boxShadow: "none", background: "none" }}>
							<AccordionSummary
								id="measure"
								expandIcon={<Icon path={mdiChevronDown} size={1} />}
								aria-controls="measure"
							>
								<h3 style={{ margin: 0 }}>
									<strong>Was messe ich einen Zylinder?</strong>
								</h3>
							</AccordionSummary>
							<AccordionDetails>
								<div style={{ overflow: "hidden" }}>
									Auf der Suche nach einer speziellen Dienstleistung oder einer
									Firma ist es heutzutage selbstverständlich, online Suchmaschinen
									zu Rate zu ziehen. Man braucht nur einige Schlagworte einzugeben
									und erhält sofort eine große Auswahl präsentiert, wobei den
									Suchergebnissen auf den ersten beiden Seiten die meiste
									Aufmerksamkeit zukommt. Einen Platz unter den Top-Listungen zu
									ergattern ist gar nicht so einfach. Neben einem ansprechenden
									Webdesign sind auch ein umfangreiches Onlinemarketing und ein
									Abstimmen auf die Suchmaschinen dafür ausschlaggebend. Als
									Internetagentur mit langjähriger Erfahrung wissen wir, worauf es
									ankommt, um gefunden zu werden. Wir pushen Ihren Online Auftritt
									und helfen Ihnen mit unseren Schulungen dabei auch selbst
									Schritte in die richtige Richtung zu setzen.
								</div>
							</AccordionDetails>
						</Accordion>
					</Grid>
				</Box> */}
			</Container>
		</>
	)
}

export default LockingSystemTypesPage
